import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

import {HttpService} from '../http.service';
import {InvestingEntityReqRes} from 'src/app/dashboard/models/InvestingEntityReqRes.model';
import {encode} from 'js-base64';
import {Base64} from 'js-base64';
import {AppSettingsService} from '../app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class LpInvestingEntityDataService {

  public readonly LP_INVESTING_ENTITIES_BASE_ENDPOINT = 'lp/investing-entities';
  public readonly LP_HOLDING_PROTFOLIO_BASE_ENDPOINT = this.appSettingsService.localEnv ? 'https://localhost:7018/api/v2/lp/protfolio/' : 'v2/lp/protfolio/';

  constructor(private http: HttpService, private appSettingsService: AppSettingsService) { }

  /** Get the invested investing entities for a holding */
  getInvestingEntitiesByHoldingId(holdingId: number): Observable<InvestingEntityReqRes[]> {
    return this.http.getTyped<InvestingEntityReqRes[]>(`${this.LP_INVESTING_ENTITIES_BASE_ENDPOINT}/holding/${holdingId}`).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  getProtfolioInvestingEntitiesByCurrentClient(): Observable<any[]> {
    return this.http.getTyped<any[]>(`${this.LP_HOLDING_PROTFOLIO_BASE_ENDPOINT}entities`).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  // get all options of entities
  getInvestingEntitiesByCurrentClient(): Observable<any[]> {
    return this.http.getTyped<any[]>(`${this.LP_INVESTING_ENTITIES_BASE_ENDPOINT}/all`).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  getSharedInvestingEntitiesForCurrentLp(): Observable<any[]> {
    return this.http.getTyped<any[]>(`${this.LP_INVESTING_ENTITIES_BASE_ENDPOINT}/myshares`).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  getSharedInvestingEntitiesByCurrentClient(): Observable<any[]> {
    return this.http.getTyped<any[]>(`${this.LP_INVESTING_ENTITIES_BASE_ENDPOINT}/shared`).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }


  createSharedEntitiesForUserByCurrentClient(email: string, investingEntitiesIds: number[]) {
    const model = {email, investingEntitiesIds};
    return this.http.postTyped<boolean>(`${this.LP_INVESTING_ENTITIES_BASE_ENDPOINT}/shared`, model).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  updateAccessForUserByCurrentClient(userEmail: string, investingEntitiesIds: number[]) {
    const dto = {email: userEmail, investingEntitiesIds};
    return this.http.putTyped<boolean>(`${this.LP_INVESTING_ENTITIES_BASE_ENDPOINT}/shared`, dto).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  removeAccessForUserByCurrentClient(userEmail: string): Observable<boolean> {
    const email = Base64.encode(userEmail);
    return this.http.deleteTyped<boolean>(`${this.LP_INVESTING_ENTITIES_BASE_ENDPOINT}/shared/${email}`).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  resendSharedInvitation(userEmail: string): Observable<boolean> {
    const email = Base64.encode(userEmail);
    return this.http.postTyped<boolean>(`${this.LP_INVESTING_ENTITIES_BASE_ENDPOINT}/shared/resend/${email}`, null).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

}
